<template>
  <div>
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        :color="secondColor"
        dark
      >
        <v-card-text>
          <v-col class="text-center" >
            Por favor aguarda un momento
          </v-col>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as constants from '../../../constants.json'

export default {
  props: ['onLoading'],
  data () {
    return {
      dialog: this.onLoading,
      secondColor: constants.SECONDARYCOLOR
    }
  },
  computed: {
    loading () {
      return this.onLoading
    }
  }
}
</script>
